/* tslint:disable */
/* eslint-disable */
/**
 * Survey API
 * API for managing Surveys and Questions.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SurveyDetailDto } from './SurveyDetailDto';
import {
    SurveyDetailDtoFromJSON,
    SurveyDetailDtoFromJSONTyped,
    SurveyDetailDtoToJSON,
    SurveyDetailDtoToJSONTyped,
} from './SurveyDetailDto';

/**
 * 
 * @export
 * @interface SurveyDetailsResponseDto
 */
export interface SurveyDetailsResponseDto {
    /**
     * 
     * @type {SurveyDetailDto}
     * @memberof SurveyDetailsResponseDto
     */
    survey?: SurveyDetailDto;
}

/**
 * Check if a given object implements the SurveyDetailsResponseDto interface.
 */
export function instanceOfSurveyDetailsResponseDto(value: object): value is SurveyDetailsResponseDto {
    return true;
}

export function SurveyDetailsResponseDtoFromJSON(json: any): SurveyDetailsResponseDto {
    return SurveyDetailsResponseDtoFromJSONTyped(json, false);
}

export function SurveyDetailsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurveyDetailsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'survey': json['survey'] == null ? undefined : SurveyDetailDtoFromJSON(json['survey']),
    };
}

export function SurveyDetailsResponseDtoToJSON(json: any): SurveyDetailsResponseDto {
    return SurveyDetailsResponseDtoToJSONTyped(json, false);
}

export function SurveyDetailsResponseDtoToJSONTyped(value?: SurveyDetailsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'survey': SurveyDetailDtoToJSON(value['survey']),
    };
}

